import React from 'react';
import { useTranslation } from "react-i18next";

export default function Portfolio()
{
    const { t } = useTranslation();
    return(
        <section className="page-section portfolio" id="portfolio">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Portfolio</h2>
                <div className="row justify-content-center" style={{marginTop:'40px'}}>
                    <div className="col-md-6 col-lg-4 mb-5">
                        <div className="card centerDiv" style={{width:'20rem'}}>
                            <img src="assets/img/portfolio/redproductiva.png" class="card-img-top" alt="..."/>
                            <div className="card-body">
                                <h5 className="card-title text-center">{t('port_title1')}</h5>
                                <p className="card-text text-center">{t('port_text1')} <a href="https://mip.sbdcr.com/" target='_blank' rel="noopener noreferrer" className="enlace">{t('port_link')}</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-5">
                        <div className="card centerDiv" style={{width:'20rem'}}>
                            <img src="assets/img/portfolio/yungblut.png" class="card-img-top" alt="..."/>
                            <div className="card-body">
                                <h5 className="card-title text-center">{t('port_title2')}</h5>
                                <p className="card-text text-center">{t('port_text2')}<a href="https://yungblutmeats.com/" target='_blank' rel="noopener noreferrer" className="enlace">{t('port_link')}</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 mb-5">
                        <div className="card centerDiv" style={{width:'20rem'}}>
                            <img src="assets/img/portfolio/dellroad.png" class="card-img-top" alt="..."/>
                            <div className="card-body">
                                <h5 className="card-title text-center">{t('port_title3')}</h5>
                                <p className="card-text text-center">{t('port_text3')}<a href="http://www.dellroadtrading.com/" target='_blank' rel="noopener noreferrer" className="enlace">{t('port_link')}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}